var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0,
    width: 30,
    height: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg_icn_primary",
    d: "M25.016,5.167A14.013,14.013,0,0,0,5.2,24.985,14.013,14.013,0,1,0,25.016,5.167Zm-9.909,22.7A12.795,12.795,0,1,1,27.9,15.076,12.809,12.809,0,0,1,15.107,27.871Zm0-24.371A11.576,11.576,0,1,0,26.683,15.076,11.589,11.589,0,0,0,15.107,3.5Zm0.609,21.915V24.824a0.609,0.609,0,1,0-1.218,0v0.591a10.372,10.372,0,0,1-9.73-9.73h1.2a0.609,0.609,0,0,0,0-1.218h-1.2a10.372,10.372,0,0,1,9.73-9.73V5.327a0.609,0.609,0,1,0,1.218,0V4.737a10.372,10.372,0,0,1,9.73,9.73H24.855a0.609,0.609,0,0,0,0,1.218h0.591A10.372,10.372,0,0,1,15.716,25.415Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg_icn_secondary",
    d: "M20.469,19.1a0.609,0.609,0,0,1-.853.122l-4.874-3.656a0.609,0.609,0,0,1-.244-0.487V13.925h0V8.983a0.609,0.609,0,0,1,1.218,0v4.873h0v0.914l4.631,3.473A0.61,0.61,0,0,1,20.469,19.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnUp);
export default __webpack_public_path__ + "static/media/icn_up.ccd7da91.svg";
export { ForwardRef as ReactComponent };